import { Component } from '@angular/core';

@Component({
    selector: 'app-lovable-left-sidebar-nav',
    templateUrl: './lovable-left-sidebar-nav.component.html',
    styleUrls: ['./lovable-left-sidebar-nav.component.css'],
})
export class LovableLeftSidebarNavComponent {
    readonly logoSrc = 'assets/branding/ts-mark.svg';
    readonly activeItem = 'home';
    readonly userAvatar = 'https://truthshorts.com/api/content/logo?userID=1';

    readonly items: { id: string; label: string; badge?: number }[] = [
        { id: 'home', label: 'Home' },
        { id: 'explore', label: 'Explore' },
        { id: 'notifications', label: 'Notifications', badge: 3 },
        { id: 'messages', label: 'Messages' },
        { id: 'bookmarks', label: 'Bookmarks' },
        { id: 'profile', label: 'Profile' },
        { id: 'more', label: 'More' },
    ];
}
